<template lang="pug">
div
  sticky(className="sub-navbar")
    el-button(type='primary' size='mini' icon='el-icon-upload' @click='onSave') 保存
    form(:action='getAPI(true) + "?lang=en"' method='post' target='_blank')
      input(type='hidden' :value='getJsonFormData()' name='json')
      el-button(type='warning' size='mini' icon='el-icon-view' native-type='submit') プレビュー[英語]
    form(:action='getAPI(true) + "?lang=ja"' method='post' target='_blank')
      input(type='hidden' :value='getJsonFormData()' name='json')
      el-button(type='warning' size='mini' icon='el-icon-view' native-type='submit') プレビュー[日本語]
    el-button(v-if='getPageType !== "create"' size='mini' type='danger' icon='el-icon-delete' @click='onDelete') 削除
  .contents-container
    el-form.c-form(ref='form', :model='form', v-loading='LOADING')
      header.c-form__header
        h1 必須項目
      .c-form__body(v-if='dataloaded')
        section.c-form__item
          header.c-form__item__header.--c.--top
            h1 タイトル
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item(label='日本語')
                  el-input(v-model='form.title.ja' placeholder='名前を入力してください')
              el-col(:span='12')
                el-form-item(label='英語')
                  el-input(v-model='form.title.en' placeholder='名前を入力してください')
        section.c-form__item
          header.c-form__item__header.--c
            h1 説明文
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item(label='日本語')
                  el-input(v-model='form.description.ja' placeholder='一覧ページに表示する説明文を入力してください' type='textarea' :rows='5')
                  p.caption NEWS一覧ページに表示する説明文を入力してください。(200文字程度まで)
              el-col(:span='12')
                el-form-item(label='英語')
                  el-input(v-model='form.description.en' placeholder='一覧ページに表示する説明文を入力してください' type='textarea' :rows='5')
        section.c-form__item
          header.c-form__item__header
            h1 URL
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='24')
                el-form-item
                  el-input(v-model='form.url' placeholder='NEWS記事のURLを入力してください。')
        section.c-form__item
          header.c-form__item__header
            h1 ステータス
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item
                  el-select(v-model='form.status')
                    el-option(v-for='item in OPTIONS.status', :key='item.value', :label='item.label', :value='item.value')
        section.c-form__item
          header.c-form__item__header
            h1 日時
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item
                  el-date-picker(v-model='form.date', value-format='yyyy-MM-dd', type='date', placeholder='年月日を設定してください')
        section.c-form__item
          header.c-form__item__header
            h1 サムネイル画像
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item
                  upload-single(:form='form' datakey='thumbnail' type='thumb' ratio='news')
</template>

<script type='text/javascript'>
import Sticky from '@/components/Element/Sticky'
import UploadSingle from '@/components/Element/Upload/Single'
import form from '@/mixins/form'
export default {
  name: 'PagesPressDetail',
  mixins: [form],
  data () {
    return {
      form: {
        id: null,
        date: null,
        status: 0,
        media: null,
        url: null,
        title: {
          ja: null,
          en: null
        },
        description: {
          ja: null,
          en: null
        },
        thumbnail: {
          rectangle: null
        }
      }
    }
  },
  created () {
    this.init()
  },
  components: {
    Sticky,
    UploadSingle
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Press/Detail/index.vue